import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import './styles/index.css';
import App from './components/App.js';
import registerServiceWorker from './registerServiceWorker';

ReactGA.initialize('G-K58JX9GQK8');
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();

